export const getPlatformCapabilities = (tools = []) => {
  if (!Array.isArray(tools)) return [];

  return tools.map((tool) => ({
    name: tool.name,
    available: Boolean(tool.isEnabled),
  }));
};

export const splitToolsByAvailability = (tools = []) => {
  const capabilities = getPlatformCapabilities(tools);

  return {
    availableTools: capabilities.filter((t) => t.available),
    unavailableTools: capabilities.filter((t) => !t.available),
  };
};
